import React, { type FC, useEffect, useState } from 'react'
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, type SxProps, type Theme, Typography } from '@mui/material'
import { Warning } from '@mui/icons-material'

import { selectAuthenticatedNearExpiration, Translation } from '../../../domain'

import { Button, Countdown } from '../common'
import { FormattedTranslation } from '../Internationalization'
import { useAppState } from '../State'

const iconStyle: SxProps<Theme> = { my: 'auto', mr: 1 }
const bodyStyle: SxProps<Theme> = { py: 1 }
const countdownStyle: SxProps<Theme> = { color: 'warning.main' }

export const TokenExpiringModal: FC = () => {
    const nearExpiration = useAppState(selectAuthenticatedNearExpiration)

    const isNearExpiration = nearExpiration !== null

    const [open, setOpen] = useState<boolean>(isNearExpiration)

    /** If the expiration state has changed, then reset the modal */
    useEffect(() => setOpen(isNearExpiration), [isNearExpiration])

    if (nearExpiration === null) {
        return null
    }

    return (
        <Dialog data-testid="token-expiring-modal" open={open} disableEscapeKeyDown fullWidth maxWidth="sm">
            <DialogTitle>
                <Box display="flex">
                    <Warning color="warning" fontSize="medium" sx={iconStyle} />
                    <Typography variant="subtitle1">
                        <FormattedTranslation id={Translation.TOKEN_EXPIRING_MODAL_TITLE} />
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent dividers>
                <Typography variant="body1" sx={bodyStyle}>
                    <FormattedTranslation
                        id={Translation.TOKEN_EXPIRING_MODAL_BODY}
                        values={{
                            countdown: (
                                <Box component="span" sx={countdownStyle}>
                                    <Countdown value={nearExpiration} />
                                </Box>
                            ),
                            br: <br />,
                        }}
                    />
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button variant="secondary" onClick={() => setOpen(false)}>
                    <FormattedTranslation id={Translation.DISMISS} />
                </Button>
            </DialogActions>
        </Dialog>
    )
}
